import { useMemo } from 'react'

import { useAuthState } from './AuthProvider'

/** Roles claim from the current session, or `[]` when no session. */
export const useRoles = (): readonly string[] => {
    const state = useAuthState()
    if (state.tag === 'authenticated' || state.tag === 'refreshing') {
        return state.session.claims.roles
    }
    return EMPTY_ROLES
}

const EMPTY_ROLES: readonly string[] = Object.freeze([])

/** Convenience predicate: does the current session include `role`? */
export const useHasRole = (role: string): boolean => {
    const roles = useRoles()
    return useMemo(() => roles.includes(role), [roles, role])
}

/** Convenience predicate: does the current session include any of `roles`? */
export const useHasAnyRole = (roles: readonly string[]): boolean => {
    const owned = useRoles()
    return useMemo(() => roles.some(r => owned.includes(r)), [owned, roles])
}
